import { useState, useEffect } from "react"
import { useApolloClient, useQuery } from "@apollo/client"
import { EledoConnection, EledoConnectionsData, EledoConnectionsVars, GET_CONNECTIONS } from "graphql/EledoConnectionQueries"


function useEledoConnections({limit, page}: EledoConnectionsVars) {
  const client = useApolloClient()
  const { loading, error, data } = useQuery<EledoConnectionsData, EledoConnectionsVars>(GET_CONNECTIONS, {variables:{limit, page}})
  const [connections, setEledoConnections] = useState<EledoConnection[]>([])
  const [total, setTotal] = useState<number>(0)
  const [connectionsLoading, setEledoConnectionsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (loading){
      setEledoConnectionsLoading(true)
      return
    }

    const _connections: EledoConnection[] = data?.connections.items.map(log => structuredClone(log)) || []

    setEledoConnections(_connections)
    setTotal(data?.connections.total || 0)
    setEledoConnectionsLoading(loading)
  }, [data, client, loading])

  return { connectionsLoading, error, connections, total }
}


export default useEledoConnections